import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

function Counter({ to, suffix = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);
  const target = parseInt(to, 10) || 0;

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const tick = (now) => {
      const p = Math.min((now - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.floor(eased * target));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target]);

  return (
    <span ref={ref}>
      {val}
      {suffix}
    </span>
  );
}

export default function Stats({ settings }) {
  const stats = [
    { value: settings?.stat_years || "15", suffix: "+", label: "Years of Legacy" },
    { value: settings?.stat_students || "2000", suffix: "+", label: "Students Trained" },
    { value: settings?.stat_styles || "10", suffix: "", label: "Dance Forms" },
    { value: settings?.stat_awards || "50", suffix: "+", label: "Stage Awards" },
  ];
  return (
    <section className="bg-purple-2 py-20 md:py-28" data-testid="stats-section">
      <div className="rb-container grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: i * 0.1 }}
            className="text-center md:text-left border-l-0 md:border-l md:border-[rgba(212,175,55,0.25)] md:pl-8"
            data-testid={`stat-${i}`}
          >
            <div className="font-serif text-5xl md:text-7xl font-light gold-gradient-text leading-none">
              <Counter to={s.value} suffix={s.suffix} />
            </div>
            <p className="mt-3 text-sm uppercase tracking-[0.2em] text-[#F6F4EE]/70">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
